import { Input } from 'entities/Input'
import { useEffect, useState } from 'react'
import { useBranchStore } from 'shared/store/branchesSlice'

export const Phone = () => {
  const { branchList, branchId, updateBranch } = useBranchStore()
  const [phone, setPhone] = useState<string>('')

  useEffect(() => {
    if (branchId && branchList?.length) {
      setPhone(branchList?.find(branch => branch.Intern === branchId)?.Phone || '')
    }
  }, [branchList?.length, branchId])

  const updatePhone = () => {
    if (branchList?.find(branch => branch.Intern === branchId)?.Phone !== phone) {
      updateBranch({ Phone: phone })
    }
  }

  return <Input label='Phone' onChange={setPhone} onBlur={updatePhone} value={phone} />
}
